import React from 'react';
import TauriAccordionAttachments from '../TauriAccordionAttachments/TauriAccordionAttachments';
import OpalSamples from '../OpalSamples/OpalSamples';
import OpalReminder from '../OpalReminder/OpalReminder';
import OpalInventory from '../OpalInventory/OpalInventory';
import OpalWithdrawal from '../OpalWithdrawal/OpalWithdrawal';
import OpalOrderRequest from '../OpalOrderRequest/OpalOrderRequest';

const OpalCoverageFactory = ({ section, id }) => {
    if (!section.show) return null;
    
    switch (section.type) {
        case "file":
            return <TauriAccordionAttachments section={section} id={id} />;
        case "samples":
            return <OpalSamples section={section} id={id} />;
        case "reminder":
            return <OpalReminder section={section} id={id} />;
        case "inventory":
            return <OpalInventory section={section} id={id} />;
        case "withdrawal":
            return <OpalWithdrawal section={section} id={id} />;
        case "order":
            return <OpalOrderRequest section={section} id={id} />;
        default:
            return null; // Handle unknown types
    }
};

export default OpalCoverageFactory;